import { createContext } from "react";

import {
  Deal,
  EntitiesSupportedByEmailFeature,
  EntityTypesSupportedByEmailFeature,
} from "@mapmycustomers/shared/types/entity";

import EmailTemplateInfo from "@app/types/email/EmailTemplateInfo";

interface EmailCreationModalState {
  id: string;
  params?:
    | {
        deals?: Deal[];
        entities: EntitiesSupportedByEmailFeature[];
      }
    | { entityType: EntityTypesSupportedByEmailFeature }
    | {
        templateInfo?: EmailTemplateInfo;
      };
}

export interface EmailsCreationModalsContextValue {
  emailModals: EmailCreationModalState[];
  onEmailModalHide(id: string): void;
  onEmailModalShow(params?: EmailCreationModalState["params"]): string;
}

const EmailComposeModalsContext = createContext<EmailsCreationModalsContextValue | null>(null);

EmailComposeModalsContext.displayName = "EmailComposeModalsContext";

export default EmailComposeModalsContext;
